if (!customElements.get("ilf-modal")) {
    class IlfModal extends HTMLElement {
        constructor() {
            super()
            this.isOpen = false
        }

        connectedCallback() {
            // Move modal to body for better z-index and positioning
            if (document.body && this.parentElement !== document.body) {
                document.body.appendChild(this)
            }

            const modal = this.querySelector(".ilf-modal-content-wrapper")
            const close = this.querySelector(".ilf-modal-close")
            const modalId = this.id

            const btn = document.querySelector(`[data-ilf-modal-open="${modalId}"]`)

            if (btn && modal && close) {
                // Store references for cleanup
                this.btn = btn
                this.close = close
                this.modal = modal

                btn.addEventListener("click", this.openModal.bind(this))
                close.addEventListener("click", this.closeModal.bind(this))
                this.addEventListener("click", this.handleBackdropClick.bind(this))

                // Add keyboard support
                this.addEventListener("keydown", this.handleKeydown.bind(this))
            }
        }

        openModal() {
            this.style.display = "flex"
            this.isOpen = true
            // Prevent body scroll when modal is open
            document.body.style.overflow = "hidden"
            this.close.focus()
        }

        closeModal() {
            this.style.display = "none"
            this.isOpen = false
            // Restore body scroll when modal is closed
            document.body.style.overflow = ""
            if (this.btn) {
                this.btn.focus()
            }
        }

        handleBackdropClick(event) {
            if (event.target === this) {
                this.closeModal()
            }
        }

        handleKeydown(event) {
            if (event.key === "Escape" && this.isOpen) {
                this.closeModal()
            }
        }

        disconnectedCallback() {
            // Clean up body scroll when modal is removed
            if (this.isOpen) {
                document.body.style.overflow = ""
            }
        }
    }

    customElements.define("ilf-modal", IlfModal)
}